import imgAvatar from '@/resources/route-manager-avatar.svg'

export function Avatar() {
  return (
    <div style={{ width: 28, paddingRight: 6 }}>
      <img src={imgAvatar} />
    </div>
  )
}
